import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { CheckCircle2, ArrowRight } from 'lucide-react';

const FeatureCard = ({ 
  icon: Icon, 
  title, 
  description, 
  features = [], 
  link,
  color = '#3b82f6'
}) => {
  return (
    <div className="card-hover bg-[#162544] rounded-2xl p-8 border border-[#1e3a5f]/50 group">
      <div 
        className="w-14 h-14 rounded-xl flex items-center justify-center mb-6 transition-transform group-hover:scale-110"
        style={{ backgroundColor: `${color}20` }}
      >
        <Icon className="w-7 h-7" style={{ color }} />
      </div>

      <h3 className="text-xl font-bold text-[#f1f5f9] mb-3">
        {title}
      </h3>

      <p className="text-[#94a3b8] text-sm mb-6 leading-relaxed">
        {description}
      </p>

      {features.length > 0 && (
        <ul className="space-y-3 mb-8">
          {features.map((feature) => (
            <li key={feature} className="flex items-start gap-3 text-sm text-[#94a3b8]">
              <CheckCircle2 className="w-4 h-4 mt-0.5 flex-shrink-0" style={{ color }} />
              <span>{feature}</span>
            </li>
          ))}
        </ul>
      )}

      {link && (
        <Link to={link}>
          <Button 
            variant="ghost" 
            className="w-full justify-between text-[#f1f5f9] hover:bg-[#1e3a5f]/50 group/btn"
          >
            Learn More
            <ArrowRight className="w-4 h-4 transition-transform group-hover/btn:translate-x-1" />
          </Button>
        </Link>
      )}
    </div>
  );
};

export default FeatureCard;
